import { store } from '@strata-monorepo/find-my-plan/lib/store/useStore'
import type { IncenseFactoryInstance } from '@redventures/incense/IncenseFactory'
import { IncenseFactory } from '@redventures/incense/IncenseFactory'
import { ConsoleAdapter } from '@redventures/incense/adapters/ConsoleAdapter'

/**
 * Returns a curried `Incense` factory bound to the *current* runtime logger
 *
 * Suitable for plain TypeScript modules or Node scripts where React hooks are
 * unavailable. The function reads the logger from the Easy-Peasy `logger` slice
 * at call time, so any adapter swap (`setLogger`) takes immediate effect
 *
 * @param logPrefix Optional prefix to prepend to every error name (defaults to
 *                  `strata-find-my-plan` to match UI usage)
 * @example
 * const incense = getIncense()
 * incense(err).captureDetails({ name: 'BadThing', message: '…' }).sendError()
 */
export function getIncense(logPrefix: string = 'strata-find-my-plan'): IncenseFactoryInstance {
  const logger = store.getState().logger.logger ?? new ConsoleAdapter()
  return IncenseFactory(logger, logPrefix)
}
